import {createContext} from 'react';

export type HelpPlatform = 'web' | 'mobile';

type HelpPlatformContextValue = {
  platform: HelpPlatform;
  setPlatform: (platform: HelpPlatform) => void;
};

/**
 * Its own module so `PlatformContext.tsx` exports only its provider component
 * and keeps Vite's fast refresh (`react-refresh/only-export-components`).
 */
export const HelpPlatformContext = createContext<HelpPlatformContextValue>({
  platform: 'web',
  setPlatform: () => {},
});
